:host {
  pointer-events: none;
  user-select: none;
  display: block;
  overflow: hidden;
  position: absolute;
  top: 0;
  left: 0;
  border-radius: inherit;
  z-index: 1;
}

.c-ripple {
  position: absolute;
  pointer-events: none;
  border-radius: 50%;
  transform: scale(0);
  background: currentColor;
  opacity: 0;

  &.animate {
    animation: ripple 0.5s backwards linear;
    opacity: 0.3;
  }

  @keyframes ripple {
    100% {
      opacity: 0;
      transform: scale(5);
    }
  }
}
